export const userDocumentation = {
  title: 'Documentation utilisateur EDH Manager',
  lastUpdated: '2026-04-14 (v14)',
  sections: [
    {
      title: 'A) Gestion d\'accès',
      items: [
        'Connexion obligatoire via un code utilisateur et un mot de passe.',
        'Le superuser a accès à tous les magasins et peut gérer les codes.',
        'La section Codes utilisateurs peut être repliée pour alléger l\'interface.',
        'Un code utilisateur standard peut avoir accès à un ou plusieurs magasins.',
        'Un code invité ne demande pas de mot de passe et ne peut avoir que des droits de lecture.',
        'Chaque accès magasin est en Lecture ou Édition.',
        'Le superuser peut modifier un code existant après création (label, code, rôle, magasins, niveaux).',
        'Le superuser définit un mot de passe à la création d\'un code et peut le réinitialiser ensuite.',
      ],
    },
    {
      title: '0) Magasins',
      items: [
        'Chaque magasin possède ses propres joueurs et ses propres tournois.',
        'Sélectionnez un magasin actif avant de gérer les données.',
        'Vous pouvez créer plusieurs magasins et passer de l\'un à l\'autre.',
        'Vous pouvez aussi renommer un magasin via le bouton Editer.',
        'Un utilisateur ayant un droit Édition sur un magasin peut modifier son image d\'entête.',
        'Une image d\'entête peut être importée directement depuis votre ordinateur pour afficher une bannière sur les pages du magasin.',
        'L\'image peut être choisie par clic ou par glisser-déposer dans la zone prévue.',
        'L\'application redimensionne et compresse automatiquement l\'image avant enregistrement.',
        'Le format attendu est une image classique et la taille finale doit rester légère pour un affichage rapide.',
        'La suppression d\'un magasin est bloquée s\'il contient encore des joueurs ou des tournois.',
      ],
    },
    {
      title: '1) Prise en main rapide',
      items: [
        'Ajoutez d\'abord vos joueurs dans la section Joueurs.',
        'Créez un tournoi et sélectionnez les joueurs participants.',
        'Ouvrez le tournoi pour gérer les rounds, les tables et les résultats.',
      ],
    },
    {
      title: '2) Gestion des joueurs',
      items: [
        'Créer, modifier ou supprimer un joueur depuis la section Joueurs.',
        'Ajouter ou retirer un joueur dans un tournoi depuis la fiche du tournoi.',
      ],
    },
    {
      title: '3) Gestion des rounds et tables',
      items: [
        'Cliquez sur Générer un round pour créer automatiquement les tables.',
        'Le système évite autant que possible les répétitions de pairings.',
        'Chaque round peut être ouvert dans un nouvel onglet via Voir la ronde.',
        'Chaque round peut être affiché en mode plein écran via Plein écran.',
      ],
    },
    {
      title: '4) Saisie des résultats',
      items: [
        'Pour chaque table, utilisez Saisir résultats ou Modifier résultats.',
        'Attribuez une position à chaque joueur et cochez Draw si égalité.',
        'Le brouillon de saisie est enregistré automatiquement jusqu\'à validation.',
      ],
    },
    {
      title: '5) Classement et tiebreakers',
      items: [
        'Le classement principal est trié par Points, Victoires, Draws.',
        'En cas d\'égalité, les tiebreakers avancés sont appliqués:',
        'TB OppPts: moyenne des points des adversaires rencontres.',
        'TB OppWins: moyenne des victoires des adversaires rencontres.',
      ],
    },
    {
      title: '6) Absences et drops',
      items: [
        'Absent R+: exclut un joueur du prochain round uniquement.',
        'Drop: exclut un joueur des rounds suivants jusqu\'à réactivation.',
        'Le compteur Exclus du prochain round affiche le total des joueurs exclus.',
      ],
    },
    {
      title: '7) Recherche de cartes',
      items: [
        'La section Recherche de cartes ouvre la recherche sur Face to Face Games.',
        'Entrez un nom de carte puis cliquez sur Rechercher.',
      ],
    },
    {
      title: '10) Tableau de bord tournoi',
      items: [
        'Apparaît automatiquement dès qu\'un round est créé dans le tournoi.',
        'Ronde en cours: numéro du round actif sur le total de rounds générés.',
        'Tables terminées: combien de tables de la ronde ont leurs résultats saisis.',
        'Joueurs sans résultat: joueurs de la ronde courante sans saisie encore complétée.',
        'Joueurs actifs: total de joueurs actifs, drops et absents du prochain round.',
        'Progression globale: pourcentage de tables avec résultats sur tout le tournoi.',
      ],
    },
    {
      title: '9) Mode arbitre mobile',
      items: [
        'La saisie des résultats est optimisée pour les téléphones et tablettes.',
        'Sur mobile, le formulaire s\'ouvre en plein écran pour faciliter la saisie.',
        'Les positions s\'attribuent en tapant un grand bouton chiffre (1, 2, 3, 4).',
        'Le Draw s\'active/désactive avec un grand bouton pleine largeur.',
        'Le bouton Sauvegarder est large et placé en bas d\'écran pour un accès facile.',
        'Aucune installation n\'est requise: accessible directement depuis le navigateur mobile.',
      ],
    },
    {
      title: '8) Bonnes pratiques tournoi',
      items: [
        'Validez les résultats table par table pour garder un classement fiable.',
        'Utilisez la vue plein écran pour afficher la ronde en cours aux joueurs.',
        'Vérifiez les joueurs absents/drops avant de générer une nouvelle ronde.',
      ],
    },
    {
      title: '11) Badges joueurs',
      items: [
        'Les badges sont attribués automatiquement a partir des statistiques cumulatives.',
        'Top 1 local: joueur classe premier du magasin avec au moins une victoire.',
        'Machine a victoires: au moins 10 victoires.',
        'Specialiste podium: total de 2e + 3e + 4e places >= 12.',
        'Maitre des draws: au moins 5 matchs en draw.',
        'Veteran du club: joueur habitue avec un volume cumule (wins + podium + draws) >= 8.',
      ],
    },
  ],
};
